import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {IndividualTravelService} from 'services/calculator-items/individual-travel.service';
import {Flight} from 'models/flight';

@Component({
    selector: 'tpc-individual-flights-list',
    templateUrl: './individual-flights-list.component.html',
    styleUrls: ['./individual-flights-list.component.css']
})
export class IndividualFlightsListComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    public calculationType = 'flights';
    public flightsList: Flight[] = [];

    constructor(private travelService: IndividualTravelService,
                private footerService: FooterNavbarService,
                private router: Router
    ) {
        this.nextSub = footerService.next$.subscribe(() => this.next());
    }

    ngOnInit() {
        this.flightsList = this.travelService.getFlightsList();
    }

    next() {
        this.footerService.skip();
    }

    addFlight() {
        this.router.navigate(['/individual/travel/' + this.calculationType]);
    }

    deleteFlight(index) {
        this.travelService.deleteFromFlightsList(index);
        this.flightsList = this.travelService.getFlightsList();
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-flights-list/individual-flights-list.component.ts